module.exports = __webpack_public_path__ + "img/622.6c515241.png";